var autoLoadDuration = 4;
var eventList = ["keydown", "mousemove", "wheel", "touchmove", "touchstart", "touchend"];
var autoLoadTimeout = setTimeout(runScripts, autoLoadDuration * 1000);

// Wait for jQuery to be ready
function waitForJquery(callback) {
    if (window.jQuery) {
        callback();
    } else {
        setTimeout(function() {
            waitForJquery(callback);
        }, 50);
    }
}

eventList.forEach(function(event) {
    window.addEventListener(event, triggerScripts, { passive: true })
});

function triggerScripts() {
    clearTimeout(autoLoadTimeout);
    eventList.forEach(function(event) {
        window.removeEventListener(event, triggerScripts, { passive: true });
    });
    waitForJquery(runScripts);
}

function runScripts() {
    document.querySelectorAll("script[delay]").forEach(function(scriptTag) {
        scriptTag.setAttribute("src", scriptTag.getAttribute("delay"));
    });
}

// var autoLoadDuration = 2;
// var eventList = ["keydown", "mousemove", "wheel", "touchmove", "touchstart", "touchend"];
// var autoLoadTimeout = setTimeout(runScripts, autoLoadDuration * 1000);

// function initializeDelayedLoading() {
//     document.addEventListener('DOMContentLoaded', function() {
//         waitForJquery(runScripts);
//     });
// }

// eventList.forEach(function(event) {
//     window.addEventListener(event, triggerScripts, { passive: true })
// });
// function triggerScripts() { 
//     runScripts();
//     clearTimeout(autoLoadTimeout);
//     eventList.forEach(function(event) {
//          window.removeEventListener(event, triggerScripts, { passive: true });
//     });
// }
// function runScripts() {
//     document.querySelectorAll("script[delay]").forEach(function(scriptTag) {
//         scriptTag.setAttribute("src", scriptTag.getAttribute("delay"));
//     });
// }